module.exports = "/assets/data/3ad8690a076b5f12e2f2d56390691bcf-HS6.data.json";